import { Injectable, Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';

import { PreferencesService } from '../shared/services/preferences/preferences.service';

@Pipe({
    name: 'customDateFormat',
})
@Injectable({
    providedIn: 'root',
})
export class DateFormatPipe implements PipeTransform {
    constructor(private preferencesService: PreferencesService) {}

    public transform(value: Date | moment.Moment | string | number, format: string): string {
        if (format === 'L LT') {
            return `${moment(value).local().format('L')} ${moment(value).local().format(this.preferencesService.correctMomentTimeFormat('LT'))}`;
        }

        return moment(value).local().format(format);
    }
}
